// Gestionnaire d'événement pour notifier l'UI depuis un retour d'API
type EventTypes = "privacyApprovalRequired" | "privacyApprovalNotRequired";

type EventHandler = () => void;

const listeners: Record<EventTypes, EventHandler[]> = {
  privacyApprovalRequired: [],
  privacyApprovalNotRequired: [],
};

export const eventBus = {
  on(event: EventTypes, handler: EventHandler) {
    listeners[event].push(handler);
  },
  off(event: EventTypes, handler: EventHandler) {
    listeners[event] = listeners[event].filter((h) => h !== handler);
  },
  emit(event: EventTypes) {
    listeners[event].forEach((handler) => handler());
  },
};
